import React from 'react';
import Loader from '../components/loader';
// import Team from '../components/Team';
import HeroHeader from '../components/HeroHeader';
import TeamDetailsPage from '../components/TeamDetailsPage';
import MetaTags from '../common-components/MetaTags';
// import TeamOverview from '../components/TeamOverview';

class BioPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    //  document.title = "Our Leaders - Learn Quran Easily";
    // document.description = "Learn Quran Easily"
    setTimeout(() => {
      this.setState({ loading: false });
    }, 100); // Simulate a 3-second loading delay
  }


  render() {
    const teamData = [
      {
        image: "https://lqe-assets.learnquraneasily.in/1747143870141_Hafiz_Aamir_Qadri.jpg",
        name: "Hafiz Amir Qadri",
        role: "Hafiz",
        description: "Hafiz Amir Qadri is a respected Islamic historian, Naat Khwan, and digital content creator, known for reviving the spiritual legacy of Auliya Allah across South India. A native of Bengaluru, he pursued his Islamic education at renowned Sunni institutions, completing his Hifz under the guidance of distinguished scholars. As the founder of We Love Islam, his research-driven videos on saints and sacred sites have inspired global audiences, reaching over 40 countries. A spiritual disciple of Tajush Shariah and Sheikh-ul-Islam Syed Madani Miyan, Hafiz Amir Qadri is devoted to preserving the rich heritage of Sufism, while encouraging meaningful religious awareness through media. His humility, vision, and dedication have made him a beloved figure among seekers of truth and love for the Prophet Muhammad (Sallallahu Ta'ala Alayhi Wasallam).",
        socialLinks: [
          { icon: "fab fa-facebook-f", url: "#" },
          { icon: "fab fa-twitter", url: "#" },
          { icon: "fab fa-instagram", url: "#" },
          { icon: "fab fa-linkedin-in", url: "#" },
        ],
        sizeLg: 4,
        sizeXl: 5
      },
      {
        image: "https://lqe-assets.learnquraneasily.in/1747143977288_Mufti_Sahab.jpg",
        name: "Mufti Abu Saeed Misbahi",
        role: "Mufti",
        description: "Mufti Abu Saeed Misbahi is a respected Islamic scholar, known for his knowledge and impactful teachings. He is a graduate of Jamia Ashrafia Mubarakpur. He achieved Islamic knowledge as well as modern to guide the community. He educates the authentic knowledge of Ahl-e-Sunnat Wa Jama'at among people. ",
        socialLinks: [
          { icon: "fab fa-facebook-f", url: "#" },
          { icon: "fab fa-twitter", url: "#" },
          { icon: "fab fa-instagram", url: "#" },
          { icon: "fab fa-linkedin-in", url: "#" },
        ],
        sizeLg: 4,
        sizeXl: 4
      },
      // {
      //   image: "img/team-3.jpg",
      //   name: "Nahiyan Momen",
      //   role: "Teacher",
      //   description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      //   socialLinks: [
      //     { icon: "fab fa-facebook-f", url: "#" },
      //     { icon: "fab fa-twitter", url: "#" },
      //     { icon: "fab fa-instagram", url: "#" },
      //     { icon: "fab fa-linkedin-in", url: "#" },
      //   ],
      //   sizeLg: 4,
      //   sizeXl: 4
      // },
      // {
      //   image: "img/team-4.jpg",
      //   name: "Asfaque Ali",
      //   role: "Volunteer",
      //   description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      //   socialLinks: [
      //     { icon: "fab fa-facebook-f", url: "#" },
      //     { icon: "fab fa-twitter", url: "#" },
      //     { icon: "fab fa-instagram", url: "#" },
      //     { icon: "fab fa-linkedin-in", url: "#" },
      //   ],
      //   sizeLg: 4,
      //   sizeXl: 4
      // }
    ];

    const breadcrumbs = [
        { label: 'Home', href: '#', isCurrentPage: false },
        { label: 'Pages', href: '#', isCurrentPage: false },
        { label: 'Our Team', href: '#', isCurrentPage: true },
      ];

    return <>
   <MetaTags
      title="Our Leaders - Learn Quran Easily"
      description="Meet the visionary leaders guiding Learn Quran Easily. Learn about their dedication to providing quality Islamic education online."
      keywords="Our Leaders, Learn Quran Easily Leadership, Islamic Education Leaders, Quran Learning Team, LQE Leadership"
      author="Learn Quran Easily Team"
      url="https://learnquraneasily.in/our-leaders"
      image="https://lqe-assets.learnquraneasily.in/1747284949484_Lqe_logo.png"
    />
      {this.state.loading ? <Loader /> :
        <>
          <HeroHeader  title="Our Leaders" breadcrumbs={breadcrumbs} />
          <TeamDetailsPage teamData={teamData} />
        </>}
    </>
  }
}

export default BioPage;
